import React from 'react';
import ServicePaymentContainer from "../containers/ServicePaymentContainer"
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claro/sdkclaromicrofront'
import PaymentFormClaroSocioContainer from "../containers/PaymentFormClaroSocioContainer"

const ServicePage = ({ match, location }) => {
    const {
      params: { serviceId }
    } = match;
  
    const {
      state: { sdkClaroVersion, isClaroPartner, paymentsConfig }
    } = location;
      
    sdkclaro.getInstance().switchGoBackButton(true)

    return (
      <>
        <Page id="service-page">
          <PaymentFormClaroSocioContainer serviceConfigIndex={serviceId} sdkVersion = {sdkClaroVersion} paymentsConfig = {paymentsConfig} />
        </Page>      
      </>
  );
};


export default ServicePage
  